import React from 'react';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import Button from '../../Button/Button';
import { howItWorksModalStyles as styles } from './howItWorksModal.tailwind.js';
import ExampleImage from '../../../../assets/images/HowItWorks.png'; // Replace with your actual image path

const data = {
    Heading: "How It Works",
    Note: "Note: Power-up your token by associating it with a player and action, and earn 3x the points!"
}

export default function HowItWorksModal({ isOpen, onClose }) {
    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            disableEnforceFocus // Disable focus enforcement on the modal
            disableAutoFocus    // Disable automatic focus on modal open
            style={{ outline: 'none', border: 'none', margin: '20px' }}
        >
            <div className={styles.container} style={{ boxShadow: '0px 3px 19px 0px rgba(255, 255, 255, 0.70)' }}>
                <button onClick={onClose} className={styles.closeButton}>
                    <CloseIcon sx={{ fontSize: '16px' }} />
                </button>
                <div className={styles.innerContainer}>
                    <div className={styles.heading}>
                        {data.Heading}
                    </div>
                    <div className='flex justify-center items-center'>
                    <img src={ExampleImage} alt="How It Works" className={styles.image} />
                    </div>
                    
                    <div className={styles.note}>
                        <span>{data.Note.split(":")[0]}:&nbsp;</span>
                        <span>{data.Note.split(":")[1]}</span>
                    </div>
                    <div className={styles.buttonContainer}>
                        <Button variant="primary" onClick={onClose} className={styles.skipButton}>
                            Skip
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
